import axios from "axios";
import axiosInstance from "@/services/https/global";
import CONFIG from "@/config";

const baseUrl = `${CONFIG.BASE_URL}/audit-reporting/api/v1/approvals`;

const throwAxios = (error) => {
  if (axios.isAxiosError(error)) {
    throw error.response?.data || error;
  }
  throw new Error("An unexpected error occurred");
};

// List response is NOT wrapped in the usual {status,code,message,data} envelope -
// it comes back as {data, totalCount, pageSize, currentPage, hasNext} directly.
export const getApprovals = async (params = {}) => {
  const queryParams = {};

  if (params.page !== undefined) queryParams.page = params.page;
  if (params.size !== undefined) queryParams.size = params.size;
  if (params.sort) queryParams.sort = params.sort;
  if (params.status) queryParams.status = params.status;
  if (params.search && params.search.trim())
    queryParams.search = params.search.trim();

  try {
    const response = await axiosInstance.get(baseUrl, { params: queryParams });
    return response.data;
  } catch (error) {
    return throwAxios(error);
  }
};

export const getApprovalById = async ({ module, id }) => {
  try {
    const response = await axiosInstance.get(`${baseUrl}/${module}/${id}`);
    return response.data;
  } catch (error) {
    return throwAxios(error);
  }
};

export const approveApproval = async ({ module, id, note }) => {
  try {
    const response = await axiosInstance.post(
      `${baseUrl}/${module}/${id}/approve`,
      { note },
    );
    return response.data;
  } catch (error) {
    return throwAxios(error);
  }
};

export const rejectApproval = async ({ module, id, note }) => {
  try {
    const response = await axiosInstance.post(
      `${baseUrl}/${module}/${id}/reject`,
      { note },
    );
    return response.data;
  } catch (error) {
    return throwAxios(error);
  }
};
